import Swiper from "swiper/bundle";

const slideExitos = () => {
	const exitos = document.querySelector(".exitos")
	if(!exitos) return
	const slider = exitos.querySelector(".swiper")
	const swiper = new Swiper(slider, {
		loop: true,
		slidesPerView: 6,
		spaceBetween: 30,
	});
}

export {slideExitos};
